import {Component, OnDestroy, OnInit, ViewChild} from "@angular/core";
import {Subject} from "rxjs";
import {ChartConfiguration, ChartData, ChartType} from 'chart.js';
import {BaseChartDirective} from 'ng2-charts';

//Chart.defaults.backgroundColor = '#9BD0F5';
//Chart.defaults.borderColor = '#36A2EB';
//Chart.defaults.color = '#000';

@Component({
  selector: "app-dashboard-page",
  templateUrl: "./dashboard-page.component.html",
  styleUrls: ["./dashboard-page.component.scss"]
})
export class DashboardPageComponent implements OnInit, OnDestroy {
  private unsubscribe$ = new Subject<void>();

  @ViewChild(BaseChartDirective) chart?: BaseChartDirective;

  reports: any[] = [
    {value: 'generalReport', label: 'Sales Report'},
    {value: 'performanceReport', label: 'Company Efficiency'},
    {value: 'communicationsReport', label: 'Customer Insights'},
    {value: 'v', label: 'Inventory Trends'},
  ];

  selectedReport = "generalReport";

  public reportDate: Date = new Date(); // Default to today's date

  // Chart configuration
  public lineChartType: ChartType = 'bar';

  lineChartDuration = 30;

  selectedDataset: string = "sold";

  public lineChartData: ChartData<'line'> = {
    labels: this.generateDateLabels(30),
    datasets: [
      {
        data: this.generateRandomData(30),
        label: 'Vehicles Sold',
        backgroundColor: 'rgba(90, 164, 84, 0.5)',
        borderColor: 'rgba(90, 164, 84, 1)',
        pointBackgroundColor: 'rgba(90, 164, 84, 1)',
        pointBorderColor: '#fff',
        pointHoverBackgroundColor: '#fff',
        pointHoverBorderColor: 'rgba(90, 164, 84, 1)',
        fill: 'origin',
      }
    ]
  };

  public lineChartOptions: ChartConfiguration['options'] = {
    animation: false,
    responsive: true,
    maintainAspectRatio: false,
    elements: {
      line: {
        tension: 0.4
      }
    },
    scales: {
      x: {
        title: {
          display: true,
          text: 'Day'
        }
      },
      y: {
        title: {
          display: true,
          text: 'Vehicles Sold'
        },
        beginAtZero: true
      }
    },
    plugins: {
      legend: {
        display: true,
        position: 'bottom'
      },
      title: {
        display: true,
        text: '30-Day Vehicle Sales'
      }
    }
  };

  constructor() {
  }

  ngOnInit(): void {
    // Initialization logic
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  // Generate date labels for the last 30 days
  private generateDateLabels(days: number): string[] {
    const labels = [];
    const today = new Date();

    for (let i = 0; i < days; i++) {
      const date = new Date(today);
      date.setDate(date.getDate() - (days - i - 1));
      labels.push(`${date.getMonth() + 1}/${date.getDate()}`);
    }

    return labels;
  }

  // Generate random data points
  private generateRandomData(count: number): number[] {
    return Array.from({length: count}, () => Math.floor(Math.random() * 50) + 30);
  }

  dateChanged(newDate: Date | null): void {
    if (newDate) {
      this.reportDate = newDate;
      console.log("Selected date:", this.reportDate);
      this.updateMockData()
    }
  }

  updateMockData() {
    this.lineChartData = {
      labels: this.generateDateLabels(this.lineChartDuration),
      datasets: [
        {
          data: this.generateRandomData(this.lineChartDuration),
          label: 'Vehicles Sold',
          backgroundColor: 'rgba(90, 164, 84, 0.5)',
          borderColor: 'rgba(90, 164, 84, 1)',
          pointBackgroundColor: 'rgba(90, 164, 84, 1)',
          pointBorderColor: '#fff',
          pointHoverBackgroundColor: '#fff',
          pointHoverBorderColor: 'rgba(90, 164, 84, 1)',
          fill: 'origin',
        }
      ]
    };
  }
}
